import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { UserMessage } from '../../../common/Types';
import { SYM } from '../../Components/MaterialSymbol';

const VOICE = speechSynthesis.getVoices().find((voice) => voice.lang === 'en-US');

export type AiMessageReaderProps = {
  messages: UserMessage[];
  onSpeakingChange?: (speaking: boolean) => void;
};

export const AiMessageReader: FC<AiMessageReaderProps> = ({ messages = [], onSpeakingChange }) => {
  const [aiSpeakingOn, setAiSpeakingOn] = useState(false);
  const lastAssistantMessage = useMemo<UserMessage | undefined>(() => {
    return [...messages].filter(({ role }) => role === 'assistant').pop();
  }, [messages]);
  const lastMessageISFromAssistant = useMemo(() => messages[messages.length - 1]?.role === 'assistant', [messages]);
  const onToggleAiSpeaking = useCallback(() => setAiSpeakingOn((v) => !v), []);

  useEffect(() => {
    if (aiSpeakingOn && lastAssistantMessage && lastMessageISFromAssistant) {
      const timeoutId = setTimeout(() => {
        const utterance = new SpeechSynthesisUtterance(lastAssistantMessage.content);

        if (VOICE) {
          utterance.voice = VOICE;
        }

        utterance.onstart = (event) => {
          onSpeakingChange?.(true);
        };

        utterance.onerror = (event) => {
          onSpeakingChange?.(false);
        };

        utterance.onend = (event) => {
          onSpeakingChange?.(false);
        };

        speechSynthesis.speak(utterance);
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [aiSpeakingOn, lastAssistantMessage, lastMessageISFromAssistant, onSpeakingChange]);

  return (
    <button type="button" onClick={onToggleAiSpeaking}>
      <SYM
        style={{
          opacity: aiSpeakingOn ? 1 : 0.5,
        }}
      >
        voice_selection
      </SYM>
    </button>
  );
};
